/**
 * The coarse routing decision produced by intent detection.
 *
 * PORTED FROM: `KnowledgeDiscoveryJiraSearchClassificationType`
 * https://bitbucket.org/atlassian/xp-knowledge-discovery/src/f02f6dd19b50e91f20c6ab94d493ce7764e76eb1/src/main/java/io/atlassian/micros/xpknowledgediscovery/dto/jiraintentdetection/KnowledgeDiscoveryJiraSearchClassificationType.java
 *
 * Values are spelled exactly as the backend enum so local and server-side
 * classifications are directly comparable in analytics.
 */
export const INTENT_TYPE = {
	/** Send the input to full page search. */
	FPS: 'FPS',
	/** Send the input to Jira's navigation destination. */
	GNIN: 'GNIN',
	/** Send the input to full-page chat. */
	CHAT: 'CHAT',
} as const;

/**
 * The product a user is primarily working in, used to decide which matchers
 * apply and in what order.
 *
 * Only products with product-specific intent detection appear here. Callers
 * elsewhere omit the field entirely, which is why it is optional.
 *
 * NOTE: the values mirror `PrimaryProductKeys` in
 * `search-page/src/common/constants/primary-product-keys.ts`. They are
 * duplicated rather than imported because `search-intent-detection` is the
 * lower-level package and must not depend on `search-page`.
 */
export const PRIMARY_PRODUCT = {
	JIRA: 'jira',
	CONFLUENCE: 'confluence',
	HOME: 'townsquare',
} as const;

/** Products whose unmatched local input can be classified by the convergence remote engine. */
export const CONVERGENCE_PRIMARY_PRODUCTS: readonly [
	typeof PRIMARY_PRODUCT.CONFLUENCE,
	typeof PRIMARY_PRODUCT.HOME,
] = [PRIMARY_PRODUCT.CONFLUENCE, PRIMARY_PRODUCT.HOME];
